import Helper from './Helper';

class DetectOs {
  constructor(config = {}) {
    this.userAgent = navigator.userAgent || navigator.vendor || window.opera;
    this.html = document.querySelector("html");

    this.addOsClass();
  }

  addOsClass() {
    const userAgent = this.userAgent;

    if (/windows phone/i.test(userAgent)) {
      Helper.addClass(this.html, 'windows');
    } else if (/android/i.test(userAgent)) {
      Helper.addClass(this.html, 'android');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      Helper.addClass(this.html, 'ios');
    }
  }
}

export default DetectOs;
